import { ZIndex } from '@/interface/enum';

export const zIndexMapping: Record<ZIndex, number> = {
    [ZIndex.HeaderSportSwitch]: 457,
    [ZIndex.HeaderMarketSwitch]: 455,
    [ZIndex.HeaderCollapse]: 453,
    [ZIndex.GenericHeader]: 457,
    [ZIndex.BottomFunction]: 522,
    [ZIndex.Widget]: 523,
    [ZIndex.BetBuilderPopup]: 1000,
    [ZIndex.VoucherRedeemPopup]: 1000,
    [ZIndex.AcceptAnyOddsPopup]: 1001,
    [ZIndex.PartialCashOutPopup]: 1000,
    [ZIndex.AcceptAnyCashOutValuePopup]: 1001,
    [ZIndex.TelegramBotPopup]: 1000,
    [ZIndex.Tutorial]: 1300,
};
